export default "__VITE_ASSET__BZEEjClC__"